module.exports = __webpack_public_path__ + "media/images/icons/outlined/border-outer-7a79a6cbfd54b213b48684b6a7905a4a.svg";